import {IComponentOptions, ILogService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {Application} from "../../../model/Application";
import {LoadingService} from "../../../loading/loading.service";
import {ApplicationService} from "../../application.service";

class OfflineModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;
    public application: Application;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: StateService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.application = this.resolve.application;
    }


    public submit() {
        window.open("/staff/applications/" + this.application.id + "/documents");
        this.$log.info("submit()");

        this.loadingService.show();

        this.applicationService.processOffline(this.application)
            .then((app) => {
                this.$log.debug("processOffline complete:", app);
                this.application = app;
                this.toaster.pop({type: "success", title: "Application processing offline"});
                this.close({$value: app});

                this.$state.go("staff.dashboard", {}, {reload: true});
            })
            .finally(() => {
                    this.loadingService.hide();
                }
            );

    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }

}

export const OfflineModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: OfflineModalController,
    template: require("./offline-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/modals/offline-modal/offline-modal.component.ts